import { Injectable } from '@angular/core';
import { NavigationEnd, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class PreviousRouteService {
  private currentRoute = '';
  private history: string[] = [];

  constructor(private router: Router) {}

  startSaveHistory(): void {
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        if (this.history[this.history.length - 1] !== event.url) {
          this.history.push(event.urlAfterRedirects);
        }

        this.currentRoute = event.url;

        if (
          this.currentRoute === '/dashboard' ||
          this.currentRoute === '/dashboard/products' ||
          this.currentRoute === '/dashboard/my-investments-list'
        ) {
          this.history = [this.currentRoute];
        }
      }
    });
  }

  getHistory(): string[] {
    return this.history;
  }

  setHistory(history: string[]): void {
    this.history = history;
  }

  popLastRoute() {
    this.history.pop();
  }

  goBack() {
    this.history.pop();

    if (this.history.length > 0 && this.history.length <= 2) {
      this.router.navigateByUrl(this.history[this.history.length - 1]);
    } else if (this.history.length > 2) {
      this.router.navigateByUrl(this.history[this.history.length - 2]);
    } else {
      this.router.navigateByUrl('/dashboard');
    }
  }

  getPreviousUrl() {
    if (this.history.length > 0) {
      return this.history[this.history.length - 2];
    }

    return '';
  }
}
